<button
  mat-raised-button
  class="qt-keyboard-key"
  tabindex="-1"
  [class.qt-keyboard-key-active]="active$ | async"
  [class.qt-keyboard-key-pressed]="pressed$ | async"
  [ngClass]="cssClass"
  (click)="onClick($event)">
  @if (hasIcon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  @if (!hasIcon) {
    {{ key }}
  }
</button>
